export default __webpack_public_path__ + "static/media/Kelly_Mitchell_AHV_In_Moms_We_Trust.35218d29.jpg";